import { render } from "./MergeVideos.vue?vue&type=template&id=2f4b0cea&scoped=true"
import script from "./MergeVideos.vue?vue&type=script&lang=js"
export * from "./MergeVideos.vue?vue&type=script&lang=js"

import "./MergeVideos.vue?vue&type=style&index=0&id=2f4b0cea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4b0cea"]])

export default __exports__